// components
import NavBar from "./NavBar.js";

function Header(props) {
    const { pageSections, typewriterText, setActiveTab } = props;

    return (
        <header>
            <div className="wrapper">
                <NavBar
                    pageSections={pageSections}
                    setActiveTab={setActiveTab}
                />
                <div className="headerContainer">
                    <div className="headerText">
                        <h1>Caitlin Klotz</h1>
                        {/* div for typewriter effect */}
                        <div>
                            <h2>{typewriterText}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;